<template>
  <div class="groupContainer">
    <div>
      <div v-if="!isHorizontal">{{ field.name }}</div>
      <div
        v-for="(group, index) in groups"
        :key="index+'facility group'"
        class="d-flex align-items-center">
        <div class="w-100" :class="isHorizontal ? 'd-flex' : ''">
          <div class="">
            <div class="d-flex justify-content-between align-items-start">
              <span class="text-error" v-if="error">{{ error }}</span>
              <div class="">
                <FacetedSearch
                  v-if="!group.isAnotherFacility"
                  :options="facetedSearchOptions"
                  @search="setFacetedFilters"
                  :showOptions="true"
                  :optionsToShow="formattedOptions"
                  @onSelectOption="onSelectOption"
                  :itemIndex="index"
                  :isHorizontal="true"
                  @clear="onClearFacetedSearch"
                  :disabled="isSelectDisabled"
                  :showFieldBottom="true"
                />
                <!-- <v-select
                  style="min-width: 190px"
                  v-if="!group.isAnotherFacility"
                  v-model="group.facility"
                  :options="formattedOptions"
                  :filterable="false"
                  :multiple="false"
                  :clearable="true"
                  ref="selectable"
                  :placeholder="$t(placeholderTranslation)"
                  @search="onSearch"
                  @input="onChangeSelect(index)"
                  class="w-100 white-bg"
                  :disabled="isSelectDisabled"
                  append-to-body
                >
                  <template #list-footer>
                    <li v-if="meta.total > 10" class="pagination">
                      <BButton
                        variant="outline-primary"
                        size="sm"
                        :disabled="!hasPrevPage"
                        @click="prevPage"
                      >
                        <feather-icon icon="ChevronLeftIcon" size="16"/>
                      </BButton>
                      <BButton
                        variant="outline-primary"
                        size="sm"
                        :disabled="!hasNextPage"
                        @click="nextPage"
                      >
                        <feather-icon icon="ChevronRightIcon" size="16"/>
                      </BButton>
                    </li>
                  </template>
                </v-select> -->
                <b-form-group
                  v-if="group.isAnotherFacility"
                  class="">
                  <b-form-input
                    style="min-width: 180px"
                    id="another_facility"
                    v-model="group.anotherFacility"
                    :disabled="isSelectDisabled"
                    @input="onChangeAnotherFacility(index)"
                  />
                  <div class="textHinnt">{{ $t('operational_security.prefill.another_facility') }}</div>
                </b-form-group>
                <b-form-checkbox
                  :id="uniqueId+'isAnotherFacility'+index"
                  v-model="group.isAnotherFacility"
                  name="isAnotherFacility"
                  :value="1"
                  class="text-capitalize my-1 cursor-pointer ml-1"
                  :unchecked-value="0"
                  :disabled="isSelectDisabled"
                  @input="onChangeIsAnotherFacility(index)"
                >
                  {{ $t("operational_security.prefill.another_facility") }}
                </b-form-checkbox>
              </div>
              <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group-horizontal mb-1">Remove</a>
            </div>

          </div>
          <div :class="isHorizontal ? 'd-flex' : ''" v-if="!group.isAnotherFacility">
            <b-form-group
              class="labelForSelect ml-1"
              style="min-width: 180px">
              <b-form-input
                id="name_facility"
                :value="group.facility ? group.facility.label : ''"
                disabled
              />
              <div class="textHinnt">Nombre</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.sirh"
              class="labelForSelect ml-1"
              style="min-width: 150px">
              <b-form-input
                id="sirh_facility"
                v-model="group.sirh"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">SIRH</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.rems"
              class="labelForSelect ml-1"
              style="min-width: 150px">
              <b-form-input
                id="rems_facility"
                v-model="group.rems"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">REMS</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.id_seproban"
              class="labelForSelect ml-1"
              style="min-width: 150px">
              <b-form-input
                id="subregion_facility"
                v-model="group.id_seproban"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">ID SEPROBAN</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.categories"
              class="labelForSelect ml-1"
              style="min-width: 150px">
              <b-form-input
                id="categorias_facility"
                v-model="group.categories"
                :disabled="isSelectDisabled"
              />
              <div class="textHinnt">Categorías</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.region"
              style="min-width: 150px"
              class="labelForSelect ml-1">
              <b-form-input
                id="region_facility"
                v-model="group.region"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">Estado</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.municipality"
              style="min-width: 150px"
              class="labelForSelect ml-1">
              <b-form-input
                id="sirh_facility"
                v-model="group.municipality"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">Municipio</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.subregion"
              style="min-width: 150px"
              class="labelForSelect ml-1">
              <b-form-input
                id="subregion_facility"
                v-model="group.subregion"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">Subregión</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.lat"
              style="min-width: 150px"
              class="labelForSelect ml-1">
              <b-form-input
                id="subregion_facility"
                v-model="group.lat"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">Latitud</div>
            </b-form-group>
            <b-form-group
              v-if="extraFieldsConf.lng"
              style="min-width: 150px"
              class="labelForSelect ml-1">
              <b-form-input
                id="subregion_facility"
                v-model="group.lng"
                :disabled="isSelectDisabled"
                @input="onChange(index)"
              />
              <div class="textHinnt">Longitud</div>
            </b-form-group>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isSelectDisabled"
      @click="addGroup"
      class="addGroupBtn"
      type="button" >
        <span>+ Instalacion</span>
    </button>
  </div>
</template>

<script>
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import axios from "@axios";
import {debounce} from "lodash";
import vSelect from "vue-select";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    vSelect,
    FacetedSearch
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const facetedSearchOptions = [
      {
        label: 'Nombre',
        value: 'description',
        isArray: false,
      },
      {
        label: 'Categoría',
        value: 'category_ss',
        isArray: false,
      },
      {
        label: 'Rems',
        value: 'rems',
        isArray: false,
      },
      {
        label: 'SIRH',
        value: 'sirh',
        isArray: false,
      },
      {
        label: 'Dirección',
        value: 'address_1',
        isArray: false,
      },
        {
          label: 'C.P.',
          value: 'postal_code',
          isArray: false,
        },
      {
        label: 'ID SEPROBAN',
        value: 'id_seproban',
        isArray: false,
      },
      {
        label: 'IP VPN',
        value: 'ip_vpn',
        isArray: false,
      },
    ];
    const extraFieldsDefault = {
      categories: true,
      region: true,
      subregion: true,
      sirh: true,
      municipality: true,
      rems: true,
      id_seproban: true,
      lat: true,
      lng: true,
    }
    const extraFieldsConf = props?.field?.options?.fieldTypeCfg?.data[0] ?? extraFieldsDefault;
    const entity = 'Facility';
    const endpoint = '/v1/unit';
    const mapOptions = (item) => ({
      value: item.id,
      label: `${item.sirh ?? ''}-${item.description}`,
      categories: [item?.category],
      region: item?.region?.name,
      subregion: item?.sector?.name,
      sirh: item?.sirh,
      municipality: item?.municipality?.name,
      rems: item?.rems,
      id_seproban: item?.id_seproban,
      lat: item?.lat,
      lng: item?.lng,
    });
    const placeholderTranslation = 'custom_forms.select_facility';
    const defaultFacilityData = {
      facility: null,
      categories: null,
      region: null,
      subregion: null,
      sirh: null,
      municipality: null,
      rems: null,
      id_seproban: null,
      isAnotherFacility: false,
      anotherFacility: "",
      lat: null,
      lng: null,
    }
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const groups = ref([{...defaultFacilityData}]);

    // Pagination
    const search = ref('');
    const limit = ref(8);
    const currentPage = ref(1);
    const meta = ref(null);
    const options = ref([]);
    const isSelectDisabled = ref(false);
    const showBtnGroup = ref(false);
    const error = ref(props.errors);
    const facetedFilters = ref({});
    const buildSuffix = (base, key) => {
      return `${base} [${key}]`;
    }

    const base = props.field.originalName;
    const exFieldCategories = buildSuffix(base, 'Categorías');
    const exFieldRegion = buildSuffix(base, 'Estado');
    const exFieldSubregion = buildSuffix(base, 'Subregión');
    const exFieldSirh = buildSuffix(base, 'SIRH');
    const exFieldMunicipality = buildSuffix(base, 'Municipio');
    const exFieldRems = buildSuffix(base, 'REMS');
    const exFieldIdSeproban = buildSuffix(base, 'ID SEPROBAN');
    const exFieldId = buildSuffix(base, 'id');
    const exFieldName = buildSuffix(base, 'name');
    const exFieldLat = buildSuffix(base, 'Lat');
    const exFieldILng = buildSuffix(base, 'Lng');
    const exFields = {
      self: props.field.originalName,
      categories: exFieldCategories,
      region: exFieldRegion,
      subregion: exFieldSubregion,
      questionLabel: props.field.name,
      sirh: exFieldSirh,
      municipality: exFieldMunicipality,
      rems: exFieldRems,
      id_seproban: exFieldIdSeproban,
      id: exFieldId,
      name: exFieldName,
      lat: exFieldLat,
      lng: exFieldILng,
    }
    const questionLabel = props.field.name

    onMounted(() => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
      showBtnGroup.value = props?.field?.options?.isGroup;
      fetchData();
    });


    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get(endpoint, {
          params: {
            q: search.value,
            max: limit.value,
            'page[n]': currentPage.value,
            sortBy: 'id',
            'with[]': 'municipality',
            ...facetedFilters.value
          },
        });
        meta.value = data.meta;
        options.value = data.data;
      } catch (error) {
        console.error(`${entity}Select: request error`, error?.response || error);
      }
    }

    // Computed properties
    const formattedOptions = computed(() => {
      return (options.value || [])
        .slice()
        .map(mapOptions);
    });

    const hasNextPage = computed(() => {
      return meta.value ? meta.value.current_page < meta.value.last_page : false;
    });

    const hasPrevPage = computed(() => {
      return meta.value ? meta.value.current_page - 1 > 0 : false;
    });

    // Watchers
    watch(currentPage, fetchData);

    // Methods
    function onChangeSelect(index) {
      const group = groups.value[index]
      const facility = group.facility || {}

      group.categories =
        (facility.categories || []).map(c => c?.name).join(', ') || null

      group.region = facility.region
      group.subregion = facility.subregion
      group.sirh = facility.sirh
      group.municipality = facility.municipality
      group.rems = facility.rems
      group.id_seproban = facility.id_seproban
      group.lat = facility?.lat
      group.lng = facility?.lng

      group.facility = {
        label: facility.label,
        value: facility.value
      }

      sendModelValue()
    }

    function onChange() {
      sendModelValue()
    }

    function setFacilityValues(data) {
      if(!data) return;
      const modelToShow = !showBtnGroup.value && data.length > 1
      ? data.slice(0, 1)
      : data;
      groups.value = modelToShow.map(item => ({
        facility: item[exFields.self] || null,
        categories: item[exFields.categories] ?? null,
        region: item[exFields.region] ?? null,
        subregion: item[exFields.subregion] ?? null,
        sirh: item[exFields.sirh] ?? null,
        municipality: item[exFields.municipality] ?? null,
        rems: item[exFields.rems] ?? null,
        id_seproban: item[exFields.id_seproban] ?? null,
        anotherFacility: item?.anotherFacility ?? "",
        isAnotherFacility: item?.isAnotherFacility ?? false,
        lat: item?.[exFields.lat] ?? null,
        lng: item?.[exFields.lng] ?? null,
      }));
    }

    function sendModelValue() {
      const result = groups.value.map((item, index) => {
        const model = {
          [exFields.self]: {
            label: item.facility?.label,
            value: item.facility?.value
          }
        }

        const map = {
          categories: exFields.categories,
          region: exFields.region,
          subregion: exFields.subregion,
          sirh: exFields.sirh,
          municipality: exFields.municipality,
          rems: exFields.rems,
          id_seproban: exFields.id_seproban,
          isAnotherFacility: "isAnotherFacility",
          anotherFacility: "anotherFacility",
          id: exFields.id,
          name: exFields.name,
          lat: exFields.lat,
          lng: exFields.lng
        }

        Object.keys(map).forEach(key => {
          if (extraFieldsConf[key] === true && key in item) {
            model[map[key]] = item[key]
          }
          if(key === "isAnotherFacility" || key === "anotherFacility") {
            model[key] = item[key]
          }
          if(key === "id") {
            model[exFields.id] = item?.facility?.value
          }
          if(key === "name") {
            model[exFields.name] = item?.facility?.label
          }
        })
        return model
      })
      emit("updateData", props.field, result);
      emit("setLastFacilitySelected", groups.value[0]);
    }

    function addGroup() {
      groups.value.push({...defaultFacilityData})
      sendModelValue()
    }

    function removeGroup(index) {
      groups.value.splice(index, 1);
      sendModelValue()
    }

    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        currentPage.value = 1;
        await fetchData();
        loading(false);
      } else {
        currentPage.value = 1;
        search.value = '';
        await fetchData();
      }
    }, 500);

    function nextPage() {
      currentPage.value += 1;
    }

    function prevPage() {
      currentPage.value -= 1;
    }

    function onChangeAnotherFacility(index) {
      groups.value[index].facility = {value: null, label: groups.value[index].anotherFacility}
      onChange()
    }
    function onChangeIsAnotherFacility(index) {
      groups.value[index].categories = null;
      groups.value[index].region = null;
      groups.value[index].subregion = null;
      groups.value[index].sirh = null;
      groups.value[index].municipality = null;
      groups.value[index].rems = null;
      groups.value[index].id_seproban = null;
      groups.value[index].facility = null;
      groups.value[index].anotherFacility = null;
      groups.value[index].lat = null;
      groups.value[index].lng = null;
    }

    const setFacetedFilters = (filters) => {
      facetedFilters.value = {...filters, ...{advanced_search: true}}
      fetchData();
    };

    const onSelectOption = (val, index) => {
      if(!val) return;
      groups.value[index].facility = val;
      onChangeSelect(index)
    };

    const onClearFacetedSearch = () => {
      groups.value = [{...defaultFacilityData}];
    };

    return {
      formattedOptions,
      meta,
      placeholderTranslation,
      isSelectDisabled,
      hasNextPage,
      hasPrevPage,
      onSearch,
      groups,
      questionLabel,
      showBtnGroup,
      extraFieldsConf,
      error,
      uniqueId,
      facetedSearchOptions,
      nextPage,
      prevPage,
      onChange,
      addGroup,
      removeGroup,
      onChangeSelect,
      onChangeAnotherFacility,
      onChangeIsAnotherFacility,
      setFacetedFilters,
      onSelectOption,
      onClearFacetedSearch
    }
  }
}
</script>

<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
  .textHinnt {
    color: #d3d3d3;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.groupContainer {
  // border: 1px solid #efefef;
  border-radius: 0.3em;
}
.white-bg {
  background-color: #fff;
}
.text-error {
  color: #ec0303;
}
.textHinnt {
  color: #5e5873;
  font-size: 1em;
  margin-top: 5px;
}
.btn-remove-group-horizontal {
  position: relative;
  color: transparent !important;
  margin: 0 0 0px 15px;
  border: 1px solid #e74c3c !important;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}
.btn-remove-group-horizontal::after {
  content: "Eliminar";
  color: #fff;
  position: absolute;
  top: 4px;
  left: 12px;
  color: #e74c3c !important;
}
.btn-remove-group-horizontal:hover {
  background: #ffecec !important;
}
</style>
